import React from 'react';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';

import Desktop from './Desktop';
import Mobile from './Mobile';
import { submitContactMessage } from '../../../../actions/contactActions';


class Component extends React.Component {
  constructor(props) {
    super(props);
    this.submit = this.submit.bind(this);
    this.updateName = this.updateName.bind(this);
    this.updateEmail = this.updateEmail.bind(this);
    this.updateMessage = this.updateMessage.bind(this);

    this.state = {
      name: "",
      email: "",
      message: "",
    };
  }

  submit() {
    this.props.submit(this.state.name, this.state.email, this.state.message);
  }

  updateName(e) {
    this.setState({ name: e.target.value });
  }

  updateEmail(e) {
    this.setState({ email: e.target.value });
  }

  updateMessage(e) {
    this.setState({ message: e.target.value });
  }

  render() {
    return (
      <div>
        <MediaQuery minWidth={769}>
          <Desktop updateName={this.updateName}
                   updateEmail={this.updateEmail}
                   updateMessage={this.updateMessage}
                   submit={this.submit}
                   loading={this.props.loading}
                   error={this.props.error}
          >
            { this.props.children }
          </Desktop>
        </MediaQuery>
        <MediaQuery maxWidth={768}>
          <Mobile updateName={this.updateNamek}
                  updateEmail={this.updateEmail}
                  updateMessage={this.updateMessage}
                  submit={this.submit}
                  loding={this.props.loading}
                  error={this.props.error}
          >
            { this.props.children }
          </Mobile>
        </MediaQuery>
      </div>
    );
  }
}

function getState(state) {
  return {
    loading: state.contact.loading,
    error: state.contact.error,
  };
}

function getActions(dispatch) {
  return {
    submit: (name, email, message) => { dispatch(submitContactMessage(name, email, message)) },
  };
}

Component.displayName = "Contact";

export default connect(getState, getActions)(Component);



// WEBPACK FOOTER //
// ./src/forms/Contact/components/Contact/index.js